import ImageCropperModal from '../components/ImageCropperModal';
import { getSharedFilters, saveSharedFilters } from '../utils/filterStore';
import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { API_URL as CONFIG_API_URL } from '../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';
import * as XLSX from 'xlsx';
import { Search, Crop, Filter, Download, ExternalLink, ChevronLeft, ChevronRight, MessageSquare, ChevronDown, Check, X, FileText, Target, Activity, ShoppingBag } from 'lucide-react';

const engineLogos = {
  /* INJECTED_MB_PC_LOGOS_v2 */
  '豆包': '/icons/doubao.png',
  '豆包(PC)': '/icons/doubao.png',
  '豆包(MB)': '/icons/doubao.png',
  '豆包（PC）': '/icons/doubao.png',
  '豆包（MB）': '/icons/doubao.png',
  'doubao': '/icons/doubao.png',
  '腾讯元宝(PC)': '/icons/yuanbao.png',
  '腾讯元宝(MB)': '/icons/yuanbao.png',
  '腾讯元宝（PC）': '/icons/yuanbao.png',
  '腾讯元宝（MB）': '/icons/yuanbao.png',
  '通义千问': '/icons/tongyi.png',
  '通义千问(PC)': '/icons/tongyi.png',
  '通义千问(MB)': '/icons/tongyi.png',
  '通义千问（PC）': '/icons/tongyi.png',
  '通义千问（MB）': '/icons/tongyi.png',
  '通义': '/icons/tongyi.png',
  '文心一言': '/icons/wenxin.png',
  '文心一言(PC)': '/icons/wenxin.png',
  '文心一言(MB)': '/icons/wenxin.png',
  'Deepseek': '/icons/deepseek.png',
  'DeepSeek': '/icons/deepseek.png',
  'deepseek': '/icons/deepseek.png',
  'Kimi': '/icons/kimi.png',
  'kimi': '/icons/kimi.png',
  '元宝': '/icons/yuanbao.png',
  '百度AI搜索': '/icons/baidu.png',
  '小红书AI': '/icons/xiaohongshu.png',
  '抖音AI': '/icons/douyin.png',
  '小红书': '/icons/xiaohongshu.png',
  'xhs': '/icons/xiaohongshu.png',
  '微信搜一搜': '/icons/wechat.png',
  '微信': '/icons/wechat.png',
};


// 模拟的溯源明细数据


const SentimentBadge = ({ type }) => {
  const styles = {
    positive: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    controversial: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    neutral: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
    negative: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
  };
  const labels = { positive: '● 正面', neutral: '● 中性', negative: '● 负面' };
  

  
  return (

    <span className={`px-2.5 py-1 text-xs rounded-full border ${styles[type]}`}>
      {labels[type]}
    </span>
  );
};

export default function MentionRecords() {
  const location = useLocation();
  const fetchMode = localStorage.getItem('globalFetchMode') || 'hybrid';
  
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const keyword = params.get('keyword');
    if (keyword) {
      setSearchTerm(keyword);
    }
  }, [location.search]);

  const [openDropdown, setOpenDropdown] = useState(null);
  const filterBarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
  
  return (
) => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterBarRef]);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const [loading, setLoading] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [cropTarget, setCropTarget] = useState(null);

  const handleCropComplete = async (base64Image) => {
        if (!cropTarget) return;
        try {
            const resRaw = await fetch(`/api/results/${cropTarget.recordId}/update-card-image`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({
                    cardIndex: cropTarget.cardIndex,
                    base64Image
                })
            });
            const res = { data: await resRaw.json() };
            if (res.data.success) {
                if (selectedRecord && selectedRecord.id === cropTarget.recordId) {
                    const newCards = [...(typeof selectedRecord.productCards === 'string' ? JSON.parse(selectedRecord.productCards) : selectedRecord.productCards)];
                    newCards[cropTarget.cardIndex].imageUrl = res.data.newImageUrl;
                    setSelectedRecord({ ...selectedRecord, productCards: JSON.stringify(newCards) });
                }
                setRecords(prev => prev.map(item => {
                    if (item.id === cropTarget.recordId) {
                        const newCards = [...(typeof item.productCards === 'string' ? JSON.parse(item.productCards) : item.productCards)];
                        newCards[cropTarget.cardIndex].imageUrl = res.data.newImageUrl;
                        return { ...item, productCards: JSON.stringify(newCards) };
                    }
                    return item;
                }));
                setCropTarget(null);
            }
        } catch (e) {
            console.error('Crop save error', e);
            alert('保存截图失败');
        }
    };
    
  
  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedRecord(null), 300);
  };

  useEffect(() => {
    const loadData = () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      const pid = localStorage.getItem('globalProject');
      const bid = localStorage.getItem('globalBrand');
      
      let url = `${API_URL}/results?limit=5000`;
      url += `&fetchMode=${localStorage.getItem('globalFetchMode') || 'hybrid'}`;
      if (pid && pid !== 'all') url += `&geoTaskId=${pid}`;
      else if (bid && bid !== 'all') url += `&brandProjectId=${bid}`;

      fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            // Map DB models to component format
            const mapped = data.data.map(item => {

            let brandsArr = [];
            try {
              if (item.mentionedBrands) brandsArr = JSON.parse(item.mentionedBrands);
            } catch(e) {}
            return {
              id: item.id,
              time: new Date(item.createdAt).toLocaleString('zh-CN', { hour12: false }),
              question: item.question || '',
              isMentioned: item.isBrandMentioned,
              brands: brandsArr,
              sentiment: item.sentiment || 'neutral',
              topic: item.themeName || '未知主题',
              platform: item.engineName || '未知引擎',
              productCards: item.productCards ? (typeof item.productCards === 'string' ? JSON.parse(item.productCards) : item.productCards) : [],
              xhsBrandDetails: item.xhsBrandDetails || [],
              xhsRawNotes: item.xhsRawNotes || [],
              rawResponse: (() => {
                let ans = (item.answer || '暂无详细回复内容');
                ans = ans.replace(/\>\s*\*\*商品卡片 \(提取\)\*\*[\s\S]*/g, '');
                ans = ans.replace(/::dqa:(quote|image|link|list|knowledge):[\s\S]*?::/g, '');
                ans = ans.replace(/::dqa:(quote|image|link|list|knowledge):[\s\S]*?::/g, '');
                ans = ans.replace(/::dqa:underline:(.*?)::/g, (match, p1) => {
                    try {
                        const obj = JSON.parse(p1);
                        return obj.text ? obj.text : p1;
                    } catch(e) { return match; }
                });
                ans = ans.replace(/\n{3,}/g, '\n\n');
                ans = ans.replace(/(\d+\.|-|\*)\s*\n+/g, '$1 ');
                return ans.trim();
              })(),
              sourceUrl: item.sourceUrl || '',
              sources: (() => {
                try {
                  let jsonSources = []; try { jsonSources = item.sources ? (typeof item.sources === 'string' ? JSON.parse(item.sources) : item.sources) : []; } catch(e) {} return (jsonSources.length >= (item.mediaSources?.length || 0)) ? jsonSources : (item.mediaSources || item.geoResultSources || []);
                } catch(e) {
                  return [];
                }
              })()
            };
          });
          setRecords(mapped);
        }
        setLoading(false);
        })
        .catch(err => {
          console.error('Failed to fetch records:', err);
          setLoading(false);
        });
    };
    
    loadData();
    window.addEventListener('globalFilterChange', loadData);
    return () => window.removeEventListener('globalFilterChange', loadData);
  }, []);

  const [filters, setFilters] = useState(() => getSharedFilters({
    engines: ['全部平台'],
    sentiments: ['全部情感']
  }));
  
  useEffect(() => {
    saveSharedFilters(filters);
  }, [filters]);

  const toggleArrayFilter = (key, value, defaultAll) => {
    setCurrentPage(1);
    setFilters(prev => {
      let current = [...prev[key]];
      if (value === defaultAll) {
        return { ...prev, [key]: [defaultAll] };
      }
      current = current.filter(v => v !== defaultAll);
      if (current.includes(value)) {
        current = current.filter(v => v !== value);
        if (current.length === 0) current = [defaultAll];
      } else {
        current.push(value);
      }
      return { ...prev, [key]: current };
    });
  };

  const renderArrayLabel = (arr, defaultAll) => {
    if (arr.includes(defaultAll)) return defaultAll;
    if (arr.length === 1) return arr[0];
    return `已选 ${arr.length} 项`;
  };



  // Filter logic
  const filteredRecords = records.filter(record => {
    // Search Term
    if (searchTerm && !record.question.toLowerCase().includes(searchTerm.toLowerCase()) && !record.brands.join(',').toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }
    
    // Platform Filter
    if (!filters.engines.includes('全部平台')) {
      const isMatch = filters.engines.some(e => e.toLowerCase() === (record.platform || '').toLowerCase());
      if (!isMatch) return false;
    }
    
    // Sentiment Filter
    if (!filters.sentiments.includes('全部情感')) {
      const sentimentMap = { 'positive': '正向', 'neutral': '中性', 'negative': '负向', 'controversial': '争议' };
      if (!filters.sentiments.includes(sentimentMap[record.sentiment])) return false;
    }
    
    return true;
  });


  const totalPages = Math.ceil(filteredRecords.length / pageSize) || 1;
  const currentRecords = filteredRecords.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const renderMentionStatus = (record) => {
    if (!record.isMentioned) {
      return <span className="inline-flex items-center px-2 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 text-xs border border-slate-200 dark:border-slate-700">⚪ 未提及</span>;
    }
    if (record.sentiment === 'positive') {
      return <span className="inline-flex items-center px-2 py-1 rounded-full bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 text-xs border border-emerald-500/20">🟢 正向评价</span>;
    }
    if (record.sentiment === 'negative') {
      return <span className="inline-flex items-center px-2 py-1 rounded-full bg-rose-500/10 text-rose-600 dark:text-rose-400 text-xs border border-rose-500/20">🔴 负向评价</span>;
    }
    if (record.sentiment === 'controversial') {
      return <span className="inline-flex items-center px-2 py-1 rounded-full bg-amber-500/10 text-amber-600 dark:text-amber-400 text-xs border border-amber-500/20">🟡 争议/多面</span>;
    }
    return <span className="inline-flex items-center px-2 py-1 rounded-full bg-blue-500/10 text-blue-600 dark:text-blue-400 text-xs border border-blue-500/20">⚪ 中立客观</span>;
  };



  const handleExport = () => {
    if (filteredRecords.length === 0) {
      alert("没有可导出的数据");
      return;
    }

    const exportData = filteredRecords.flatMap(r => {
      const sentimentMap = { 'positive': '正向', 'neutral': '中性', 'negative': '负向', 'controversial': '争议' };
      const baseInfo = {
        'AI引擎': r.platform,
        '品牌': r.brand,
        '提及状态': r.isMentioned ? '被提及' : '未提及',
        '情感极性': sentimentMap[r.sentiment] || r.sentiment,
        '触发问题 (Prompt)': r.question,
        'AI 回答内容': r.rawResponse || '-',
        '业务维度 (主题)': r.topic,
        '抓取时间': r.time
      };
      
      const isXhs = r.platform && (r.platform.toLowerCase().includes('xhs') || r.platform.includes('小红书'));

      if (isXhs && (r.xhsRawNotes?.length > 0 || r.sources?.length > 0)) {
          let allNotes = [];
          
          if (r.xhsRawNotes && r.xhsRawNotes.length > 0) {
              r.xhsRawNotes.forEach((n, idx) => {
                  allNotes.push({
                      ...baseInfo,
                      '数据类型 (Scope)': 'AIO引用文章',
                      '引用序号': idx + 1,
                      '信源媒体': n.nickname || '小红书用户',
                      '博主名字': n.nickname || '-',
                      '文章标题': n.title || '-',
                      '文章描述': n.content || '-',
                      '点赞数': n.likeCount || 0,
                      '收藏数': n.collectCount || 0,
                      '评论数': n.commentCount || 0,
                      '转发数': n.shareCount || 0,
                      '链接': (n.noteUrl && n.noteUrl !== 'about:blank') ? n.noteUrl : '-'
                  });
              });
          }
          
          if (r.sources && r.sources.length > 0) {
              r.sources.forEach((s, idx) => {
                  allNotes.push({
                      ...baseInfo,
                      '数据类型 (Scope)': '自然排名笔记',
                      '引用序号': idx + 1,
                      '信源媒体': s.name || s.mediaName || s.nickname || '-',
                      '博主名字': s.nickname || s.name || s.mediaName || '-',
                      '文章标题': s.title || '-',
                      '文章描述': s.snippet || '-',
                      '点赞数': s.likeCount || 0,
                      '收藏数': s.collectCount || 0,
                      '评论数': s.commentCount || 0,
                      '转发数': s.shareCount || 0,
                      '链接': (s.url && s.url !== 'about:blank') ? s.url : '-'
                  });
              });
          }
          
          return allNotes;
      }

      if (!r.sources || r.sources.length === 0) {
        return [{
          ...baseInfo,
          '数据类型 (Scope)': '-',
          '引用序号': '-',
          '信源媒体': '-',
          '博主名字': '-',
          '文章标题': '-',
          '文章描述': '-',
          '点赞数': '-',
          '收藏数': '-',
          '评论数': '-',
          '转发数': '-',
          '链接': '-'
        }];
      }

      return r.sources.map((s, idx) => ({
        ...baseInfo,
        '数据类型 (Scope)': '通用信源引用',
        '引用序号': idx + 1,
        '信源媒体': s.name || s.mediaName || '-',
        '博主名字': '-',
        '文章标题': s.title || '-',
        '文章描述': s.snippet || '-',
        '点赞数': '-',
        '收藏数': '-',
        '评论数': '-',
        '转发数': '-',
        '链接': (s.url && s.url !== 'about:blank') ? s.url : '-'
      }));
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AI对线溯源明细");
    XLSX.writeFile(workbook, "SapientRank_提及记录明细.xlsx");
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-[#2996cf]" />
            AI 对话溯源明细
          </h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">追踪原始对话 Prompt，监控品牌在各引擎中的具体表现。</p>
        </div>
        <button onClick={handleExport} className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg border border-gray-200 dark:border-slate-700 transition-colors">
          <Download className="w-4 h-4" />
          导出明细
        </button>
      </div>

      <div ref={filterBarRef} className="relative z-10 bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-2xl p-4 flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[200px] relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input 
            type="text" 
            placeholder="搜索品牌、原始问题或内容..." 
            className="w-full bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700/50 text-slate-700 dark:text-slate-200 text-sm rounded-lg pl-9 pr-4 py-2 focus:outline-none focus:border-[#2996cf]/50 focus:ring-1 focus:ring-[#2996cf]/50 transition-all"
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
          />
        </div>
        
        <div className="flex items-center gap-3">
          
          {/* AI Platform Filter (Multi-select) */}
          <div className="relative">
            <button 
              onClick={() => toggleDropdown('engines')}
              className="flex items-center justify-between w-[130px] px-3 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700/50 rounded-lg text-sm text-slate-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
            >
              <span className="truncate text-left">{renderArrayLabel(filters.engines, '全部平台')}</span>
              <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'engines' ? 'rotate-180' : ''}`} />
            </button>
            {openDropdown === 'engines' && (
              <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                  <span>选择平台 (可多选)</span>
                  {filters.engines.length > 0 && !filters.engines.includes('全部平台') && <span className="text-[#2996cf] cursor-pointer" onClick={() => setFilters(p => ({...p, engines: ['全部平台']}))}>重置</span>}
                </div>
                
                {['Kimi', 'DeepSeek', '豆包', '文心一言', '腾讯元宝', '通义千问', '小红书AI', '抖音AI', '百度AI搜索'].map(opt => {
                  const isDisabled = false;
                  if (opt === '豆包' || opt === '腾讯元宝' || opt === '通义千问') {
                     const baseName = opt;
                     const pcName = baseName + '(PC)';
                     const mbName = baseName + '(MB)';
                     const isMBDisabled = false; 
                     
                     return (
                        <div key={opt} className="px-4 py-2 flex flex-col gap-2 border-b border-gray-50 dark:border-slate-800/50">
                           <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-300">
                              {engineLogos[baseName] && <img src={engineLogos[baseName]} alt={baseName} className="w-4 h-4 rounded-sm object-contain" />}
                              <span>{baseName}</span>
                           </div>
                           <div className="flex gap-2 pl-6">
                              <div onClick={(e) => { e.stopPropagation(); toggleArrayFilter('engines', pcName, '全部平台') }} className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs cursor-pointer transition-colors border ${filters.engines.includes(pcName) ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                 <span>PC</span>
                              </div>
                              <div onClick={(e) => { 
                                  e.stopPropagation(); 
                                  if (!isMBDisabled) toggleArrayFilter('engines', mbName, '全部平台'); 
                                }} 
                                className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors border ${isMBDisabled ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-500' : (filters.engines.includes(mbName) ? 'bg-blue-50 border-blue-200 text-blue-700 cursor-pointer dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 cursor-pointer hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700')}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
                                 <span>MB</span>
                              </div>
                           </div>
                        </div>
                     );
                  }
                  return (
                  <div 
                    key={opt} 
                    onClick={(e) => { e.stopPropagation(); if (!isDisabled) toggleArrayFilter('engines', opt, '全部平台') }} 
                    className={`px-4 py-2 text-sm flex items-center space-x-2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-slate-900 text-gray-500' : 'text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer'}`}
                    title={isDisabled ? "暂未开放" : ""}
                  >
                    <input type="checkbox" checked={filters.engines.includes(opt)} disabled={isDisabled} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" />
                    {engineLogos[opt] && <img src={engineLogos[opt]} alt={opt} className="w-4 h-4 rounded-sm object-contain" />}
                    <span>{opt}{isDisabled ? ' (暂未开放)' : ''}</span>
                  </div>
                  );
                })}

              </div>
            )}
          </div>

          {/* Sentiment Filter (Multi-select) */}
          <div className="relative">
            <button 
              onClick={() => toggleDropdown('sentiments')}
              className="flex items-center justify-between w-[130px] px-3 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700/50 rounded-lg text-sm text-slate-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
            >
              <span className="truncate text-left">{renderArrayLabel(filters.sentiments, '全部情感')}</span>
              <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'sentiments' ? 'rotate-180' : ''}`} />
            </button>
            {openDropdown === 'sentiments' && (
              <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                  <span>选择情感 (可多选)</span>
                  {filters.sentiments.length > 0 && !filters.sentiments.includes('全部情感') && <span className="text-[#2996cf] cursor-pointer" onClick={() => setFilters(p => ({...p, sentiments: ['全部情感']}))}>重置</span>}
                </div>
                {['全部情感', '正向', '争议', '中性', '负向'].map(opt => (
                  <div key={opt} onClick={() => toggleArrayFilter('sentiments', opt, '全部情感')} className="px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2">
                    <input type="checkbox" checked={filters.sentiments.includes(opt)} readOnly className="rounded border-gray-300 text-[#2996cf] focus:ring-[#2996cf]" />
                    <span>{opt}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <button className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-white bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700/50 rounded-lg hover:border-gray-300 dark:hover:border-slate-600 transition-colors">
            <Filter className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800/40 dark:backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-2xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">
            <thead className="bg-gray-50 dark:bg-slate-800/80 border-b border-gray-200 dark:border-slate-700/50 text-slate-500 dark:text-slate-400">
              <tr>
                <th className="px-4 py-4 font-medium w-16">引擎</th>
                <th className="px-4 py-4 font-medium">业务主题/意图</th>
                <th className="px-4 py-4 font-medium min-w-[200px] max-w-[400px]">原始问题 (Prompt)</th>
                <th className="px-4 py-4 font-medium text-center">提及状态</th>
                <th className="px-4 py-4 font-medium">对话时间</th>
                <th className="px-4 py-4 font-medium text-right w-24">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-slate-700/50">
              {currentRecords.map((record) => (
                <tr key={record.id} className="hover:bg-gray-50 dark:hover:bg-slate-700/20 transition-colors">
                  <td className="px-4 py-4">
                    <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700/50" title={record.platform}>
                      {engineLogos[record.platform] ? <img src={engineLogos[record.platform]} alt={record.platform} className="w-5 h-5 rounded-sm object-contain" /> : <span className="text-[10px] text-gray-400">{record.platform?.substring(0, 2)}</span>}
                    </div>
                  </td>
                  <td className="px-4 py-4 text-slate-700 dark:text-slate-300 font-medium">
                    {record.topic}
                  </td>
                  <td className="px-4 py-4 min-w-[200px] max-w-[400px]">
                    <div className="truncate text-slate-600 dark:text-slate-400" title={record.question}>{record.question}</div>
                  </td>
                  <td className="px-4 py-4 text-center">
                    {renderMentionStatus(record)}
                  </td>
                  <td className="px-4 py-4 text-slate-500 dark:text-slate-500 text-xs">{record.time}</td>
                  <td className="px-4 py-4 text-right">
                    <button 
                      onClick={() => handleViewDetails(record)}
                      className="text-[#2996cf] hover:text-white bg-[#2996cf]/10 hover:bg-[#2996cf] px-3 py-1.5 rounded-lg text-xs transition-colors"
                    >
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="px-4 py-4 border-t border-gray-200 dark:border-slate-700/50 flex items-center justify-between text-sm text-slate-500 dark:text-slate-400">
          <div>共 {filteredRecords.length} 条溯源记录</div>
          <div className="flex items-center gap-2">
            <button 
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="p-1 hover:text-slate-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-700 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(p => p === 1 || p === totalPages || Math.abs(currentPage - p) <= 2)
              .map((page, index, array) => (
              <React.Fragment key={page}>
                {index > 0 && page - array[index - 1] > 1 && (
                  <span className="px-2 py-1 text-slate-400">...</span>
                )}
                <button
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded-md transition-colors ${
                    currentPage === page 
                      ? 'bg-[#2996cf]/10 dark:bg-[#2996cf]/20 text-[#2996cf] border border-[#2996cf]/20 dark:border-[#2996cf]/30' 
                      : 'hover:bg-gray-100 dark:hover:bg-slate-700 border border-transparent'
                  }`}
                >
                  {page}
                </button>
              </React.Fragment>
            ))}

            <button 
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className="p-1 hover:text-slate-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-700 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    
      {/* Drawer Overlay & Content */}
      <div className={`fixed inset-0 z-50 transition-opacity duration-300 ${isDrawerOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={closeDrawer}></div>
        
        {/* Drawer Panel */}
        <div className={`absolute top-0 right-0 h-full w-full sm:w-[600px] bg-white dark:bg-slate-900 border-l border-gray-200 dark:border-slate-800 shadow-2xl transition-transform duration-300 transform flex flex-col ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-800 flex items-center justify-between bg-gray-50/50 dark:bg-slate-900/50">
            <h3 className="text-lg font-semibold text-slate-800 dark:text-white flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-[#2996cf]" />
              对话溯源明细
            </h3>
            <button onClick={closeDrawer} className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar">
            {selectedRecord && (
              <>
                {/* Meta Info Grid */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-50 dark:bg-slate-800/50 rounded-xl p-4 border border-gray-100 dark:border-slate-700/50">
                    <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 mb-2">
                      <Target className="w-4 h-4" />
                      <span className="text-xs font-medium uppercase tracking-wider">引擎与意图</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm font-semibold text-slate-800 dark:text-slate-200">
                      {engineLogos[selectedRecord.platform] && <img src={engineLogos[selectedRecord.platform]} className="w-4 h-4" />}
                      {selectedRecord.platform}
                      <span className="text-gray-300 dark:text-slate-600">|</span>
                      {selectedRecord.topic}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-slate-800/50 rounded-xl p-4 border border-gray-100 dark:border-slate-700/50">
                    <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 mb-2">
                      <Activity className="w-4 h-4" />
                      <span className="text-xs font-medium uppercase tracking-wider">判定结果</span>
                    </div>
                    <div className="text-sm font-semibold">
                      {renderMentionStatus(selectedRecord)}
                    </div>
                  </div>
                </div>

                {/* Brands List */}
                {selectedRecord.brands && selectedRecord.brands.length > 0 && (
                  <div className="space-y-2">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                      <Check className="w-4 h-4 text-emerald-500" />
                      AI 推荐的品牌榜单
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedRecord.brands.map((b, i) => (
                        <span key={i} className="px-3 py-1 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-slate-600 dark:text-slate-300 shadow-sm">
                          {b}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Conversation Bubbles */}
                <div className="space-y-4 pt-4 border-t border-gray-100 dark:border-slate-800">
                  <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                    <FileText className="w-4 h-4 text-[#2996cf]" />
                    完整对话还原
                  </h4>
                  
                  {/* User Question */}
                  <div className="flex justify-end pr-2">
                    <div className="bg-[#2996cf] text-white rounded-2xl rounded-tr-sm px-5 py-3 max-w-[85%] shadow-sm">
                      <p className="text-sm whitespace-pre-wrap leading-relaxed">{selectedRecord.question}</p>
                    </div>
                  </div>

                  {/* AI Response */}
                  <div className="flex justify-start pl-2">
                    <div className="bg-gray-50 dark:bg-slate-800/80 text-slate-700 dark:text-slate-300 rounded-2xl rounded-tl-sm px-5 py-4 max-w-[95%] border border-gray-100 dark:border-slate-700 shadow-sm">
                      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200 dark:border-slate-700/50">
                        {engineLogos[selectedRecord.platform] && <img src={engineLogos[selectedRecord.platform]} className="w-5 h-5" />}
                        <span className="text-xs font-semibold">{selectedRecord.platform}</span>
                      </div>
                      <div className="text-sm leading-relaxed prose prose-sm dark:prose-invert max-w-none [&_li_p]:my-0">
                        {selectedRecord.rawResponse ? <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
                          {(() => {

                                let cleanAns = selectedRecord.rawResponse || '';
                                cleanAns = cleanAns.replace(/\>\s*.*商品卡片.*(?:(?:\r?\n)\>.*)*/g, '');
                                cleanAns = cleanAns.replace(/```json[\s\S]*?```/g, '');
                                cleanAns = cleanAns.replace(/\[\s*\{[\s\S]*\}\s*\]\s*$/, '');
                        cleanAns = cleanAns.replace(/::dqa:(quote|image|link|list|knowledge):[\s\S]*?::/g, '');
                                cleanAns = cleanAns.replace(/::dqa:underline:(.*?)::/g, (match, p1) => {
                                    try {
                                        const obj = JSON.parse(p1);
                                        return obj.text ? obj.text : p1;
                                    } catch(e) { return match; }
                                });
                                cleanAns = cleanAns.replace(/(\d+\.[^\n]+)\n+(1\.\s)/g, '$1\n\n---\n\n$2');
                                cleanAns = cleanAns.replace(/\n{3,}/g, '\n\n');
                                return cleanAns.trim();

                          })()}
                        </ReactMarkdown> : "AI回复内容未记录或获取失败。"}

                            
                            {/* 小红书 AIO 特色 UI：品牌萃取卡片 */}
                            {selectedRecord.xhsBrandDetails && selectedRecord.xhsBrandDetails.length > 0 && (
                              <div className="mt-4 mb-4">
                                <div className="flex items-center gap-1.5 text-xs text-[#ff2442] font-bold mb-3">
                                  <svg className="w-4 h-4" viewBox="0 0 1024 1024" fill="currentColor">
                                    <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#ff2442"/>
                                    <path d="M512 841.142857C329.142857 841.142857 182.857143 694.857143 182.857143 512S329.142857 182.857143 512 182.857143s329.142857 146.285714 329.142857 329.142857-146.285714 329.142857-329.142857 329.142857z" fill="#ff2442"/>
                                    <path d="M725.333333 460.8v102.4H306.041143v-102.4h419.29219z" fill="#ffffff"/>
                                    <path d="M563.2 292.571429v438.857142h-102.4V292.571429h102.4z" fill="#ffffff"/>
                                  </svg>
                                  <span>小红书 AI 专属总结 (AIO)</span>
                                  {selectedRecord.xhsBrandDetails[0]?.answerType && (
                                      <div className="ml-2 text-[10px] bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 px-1.5 py-0.5 rounded-sm border border-blue-100 dark:border-blue-800/50 inline-block">
                                        {selectedRecord.xhsBrandDetails[0].answerType}
                                      </div>
                                  )}
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  {selectedRecord.xhsBrandDetails.filter(b => b.brandName || b.mentionContent).map((bDetail, idx) => (
                                    <div key={idx} className="bg-red-50/40 dark:bg-[#ff2442]/10 border border-red-100 dark:border-red-900/30 rounded-xl p-3 relative overflow-hidden">
                                      <div className="absolute top-0 right-0 bg-[#ff2442] text-white text-[10px] font-black px-2 py-0.5 rounded-bl-lg">
                                        TOP {bDetail.brandRank || '-'}
                                      </div>
                                      <div className="flex items-center gap-2 mb-2">
                                        <div className="font-bold text-slate-800 dark:text-slate-200 text-sm">
                                          {bDetail.brandName || '未命名品牌'}
                                        </div>
                                        
                                        {bDetail.recommendRatio && (
                                          <div className="text-[10px] bg-red-100 dark:bg-red-900/50 text-[#ff2442] dark:text-red-300 px-1.5 py-0.5 rounded-sm">
                                            推荐度 {bDetail.recommendRatio}%
                                          </div>
                                        )}
                                      </div>
                                      {bDetail.mentionContent && (
                                        <div className="text-xs text-slate-600 dark:text-slate-400 line-clamp-2 mb-1" title={bDetail.mentionContent}>
                                          <span className="font-semibold text-slate-700 dark:text-slate-300">核心卖点：</span>
                                          {bDetail.mentionContent}
                                        </div>
                                      )}
                                      {bDetail.brandViewpoint && (
                                        <div className="text-xs text-slate-600 dark:text-slate-400 line-clamp-2" title={bDetail.brandViewpoint}>
                                          <span className="font-semibold text-slate-700 dark:text-slate-300">用户观点：</span>
                                          {bDetail.brandViewpoint}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}


                            {/* Product Cards UI */}
                            {selectedRecord.productCards && selectedRecord.productCards.length > 0 && (
                                <div className="mt-4 space-y-3">
                                    <div className="flex items-center gap-1.5 text-xs text-amber-600 dark:text-amber-400 font-bold mb-2">
                                        <ShoppingBag className="w-4 h-4" />
                                        <span>引擎在此回答中动态插入了以下商品导购卡片：</span>
                                    </div>
                                    <div className="flex flex-wrap gap-4">
                                        {(() => {
                                            let parsedCards = selectedRecord.productCards;
                                            if (typeof parsedCards === 'string') {
                                                try { parsedCards = JSON.parse(parsedCards); } catch(e) {}
                                            }
                                            return Array.isArray(parsedCards) ? parsedCards.map((card, idx) => (
                                                <div key={idx} className="flex bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg shadow-sm hover:shadow-md transition-shadow p-2 w-[280px] gap-3 relative group">
                                                    <div className="w-16 h-16 flex-shrink-0 rounded-md overflow-hidden bg-white dark:bg-slate-800 flex items-center justify-center border border-gray-100 dark:border-slate-600">
                                                        {(card.imageUrl || card.image_url || card.image) ? <img src={(card.imageUrl || card.image_url || card.image)} alt={(card.productName || card.product_name)} className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform cursor-pointer" onClick={() => setZoomedImage((card.imageUrl || card.image_url || card.image))} /> : <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">无图</div>}
                                                    </div>
                                                    <div className="flex flex-col justify-between overflow-hidden">
        <div>
            <div className="text-sm font-bold text-gray-800 dark:text-slate-200 truncate" title={(card.productName || card.product_name)}>{(card.productName || card.product_name)}</div>
            <div className="text-[10px] text-gray-500 dark:text-slate-400 line-clamp-2 leading-tight mt-0.5" title={(card.details || [card.price, card.meta_info].filter(Boolean).join(' | '))}>{(card.details || [card.price, card.meta_info].filter(Boolean).join(' | '))}</div>
        </div>
        <div className="mt-1 flex items-center justify-between">
            <span className="inline-block bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-[9px] px-1.5 py-0.5 rounded font-medium truncate max-w-[120px]">{(card.merchant || card.platform || card.source || '未知商家')}</span>
            
            {/* Crop Button */}
            {selectedRecord && selectedRecord.sources && selectedRecord.sources.length > 0 && (
              <button
                onClick={(e) => {
                    e.stopPropagation();
                    const srcObj = selectedRecord.sources.find(s => s.url || s.link || s.URL || s.Url) || selectedRecord.sources[0]; setCropTarget({ recordId: selectedRecord.id, cardIndex: idx, sourceUrl: srcObj.url || srcObj.link || srcObj.URL || srcObj.Url });
                }}
                className="ml-2 bg-blue-50 hover:bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:hover:bg-blue-800/50 dark:text-blue-400 p-1 rounded transition-colors"
                title="手工校准截图"
              >
                <Crop className="w-3 h-3" />
              </button>
            )}
        </div>
    </div>
                                                </div>
                                            )) : null;
                                        })()}
                                    </div>
                                </div>
                            )}

                      </div>
                      
                      
                      {/* 小红书信源瀑布流展示 */}
                      {selectedRecord.xhsRawNotes && selectedRecord.xhsRawNotes.length > 0 && (
                        <div className="mt-4 pt-3 border-t border-gray-200 dark:border-slate-700">
                          <div className="flex items-center justify-between mb-3">
                            <p className="text-xs font-bold text-[#ff2442]">AIO 引用溯源 (小红书笔记):</p>
                          </div>
                          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
                            {selectedRecord.xhsRawNotes.map((note, idx) => (
                              <div key={idx} className="break-inside-avoid bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group cursor-pointer relative" onClick={() => window.open(note.noteUrl || '#', '_blank')}>
                                {/* 笔记指标悬浮层 */}
                                <div className="absolute top-2 right-2 flex flex-col gap-1 z-10 pointer-events-none opacity-90">
                                  <div className="bg-black/50 backdrop-blur text-white text-[9px] px-1.5 py-0.5 rounded-md flex items-center gap-1">
                                    <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg>
                                    {note.likeCount || 0}
                                  </div>
                                </div>

                                <div className="p-3">
                                  <div className="text-xs font-bold text-slate-800 dark:text-slate-200 line-clamp-2 mb-1.5 leading-snug group-hover:text-[#ff2442] transition-colors">
                                    {note.title || '无标题笔记'}
                                  </div>
                                  <div className="text-[10px] text-slate-500 dark:text-slate-400 line-clamp-3 mb-2">
                                    {note.content}
                                  </div>
                                  <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-100 dark:border-slate-700/50">
                                    <div className="flex items-center gap-1.5">
                                      <div className="w-4 h-4 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center overflow-hidden">
                                        <svg className="w-2.5 h-2.5 text-slate-400" fill="currentColor" viewBox="0 0 24 24"><path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                      </div>
                                      <span className="text-[10px] text-slate-500 dark:text-slate-400 truncate max-w-[80px]">{note.nickname || '小红书用户'}</span>
                                    </div>
                                    {note.timeText && <span className="text-[9px] text-slate-400">{note.timeText}</span>}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {selectedRecord.sources && selectedRecord.sources.length > 0 && (
                          <div className="mt-4 pt-3 border-t border-gray-200 dark:border-slate-700">
                              <p className="text-xs font-bold text-gray-500 dark:text-slate-400 mb-2">
                                {(selectedRecord.platform === 'xhs' || selectedRecord.platform === '小红书' || selectedRecord.platform === '小红书AI' || selectedRecord.platform === '小红书ai') ? '小红书自然排名笔记 (Organic Results):' : '引用溯源:'}
                              </p>
                              <div className="flex flex-wrap gap-2">
                                  {selectedRecord.sources
                                    .filter(src => src.name !== '小红书AI回答' && src.title !== '小红书AI回答' && src.url !== '小红书AI回答')
                                    .map((src, i) => {
                                      const displayName = src.title || src.name || '未知来源';
                                      if (src.url && src.url.trim() !== '' && src.url !== 'brand_detail') {
                                          return (
                                              <a key={i} href={src.url} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 px-2.5 py-1 rounded border border-blue-100 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors text-xs no-underline max-w-full" title={displayName}>
                                                  <svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                                  <span className="truncate max-w-[200px]">{displayName}</span>
                                              </a>
                                          );
                                      } else {
                                          return (
                                              <span key={i} className="flex items-center space-x-1 bg-slate-50 dark:bg-slate-800/50 text-slate-600 dark:text-slate-400 px-2.5 py-1 rounded border border-slate-200 dark:border-slate-700 text-xs max-w-full cursor-default" title={displayName}>
                                                  <svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path></svg>
                                                  <span className="truncate max-w-[200px]">{displayName}</span>
                                              </span>
                                          );
                                      }
                                  })}
                              </div>
                          </div>
                        )}


                      
                    </div>
                  </div>
                </div>

                {/* Source Link if available */}
                {selectedRecord.sourceUrl && (
                  <div className="pt-4 flex justify-center">
                    <a href={selectedRecord.sourceUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-lg text-sm transition-colors">
                      <ExternalLink className="w-4 h-4" />
                      在原引擎中查看原始对话
                    </a>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Zoomed Image Modal */}
      
    {cropTarget && (
        <ImageCropperModal
            imageUrl={cropTarget.sourceUrl}
            onClose={() => setCropTarget(null)}
            onCropComplete={handleCropComplete}
        />
    )}
    {zoomedImage && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={() => setZoomedImage(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full h-full flex items-center justify-center">
            <button 
              className="absolute top-4 right-4 text-white hover:text-gray-300 z-50 p-2"
              onClick={(e) => { e.stopPropagation(); setZoomedImage(null); }}
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
            <img 
              src={zoomedImage} 
              alt="Zoomed Product" 
              className="max-w-full max-h-[90vh] object-contain rounded shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

    </div>
  );
}